<script>
import SkyWindow from 'sky-window';

export default {
	props: ['theme', 'text', 'calculate'],
	data() {
		return {
			resize: null,
			parentNode: null,
			contentNode: null,
			offsetNode: null,
			parentHeight: null,
			contentWidth: null,
			elementOffset: null,
		};
	},
	computed: {
		styleObject() {
			return this.calculate
				? {
					width: `${this.parentHeight
					+ (this.contentWidth / 16)
					- (this.elementOffset + window.pageYOffset)}px`,
				}
				: {};
		},
	},
	methods: {
		setMeasurements() {
			this.parentHeight = this.parentNode.getBoundingClientRect().height;
			this.contentWidth = this.contentNode.getBoundingClientRect().width;
			const siblingRect = this.offsetNode.getBoundingClientRect();

			this.elementOffset = siblingRect.top + (siblingRect.height * 2);
		},
	},
	mounted() {
		if (this.calculate) {
			this.parentNode = this.$el.parentNode;
			this.contentNode = this.parentNode.querySelector('.content');
			this.offsetNode = this.parentNode.querySelector('.action-bar');

			this.setMeasurements();
			this.resize = SkyWindow.resize.subscribe(this.setMeasurements);
		}
	},
	beforeDestroy() {
		if (this.resize) {
			this.resize.unsubscribe();
		}
	},
};
</script>

<template>
<div
	:class="['ge-cta-arrow', theme]"
	:style="styleObject"
>
	<span v-text="text"></span>
	<sky-svg name="wedge"></sky-svg>
</div>
</template>

<style src="./ge-cta-arrow.scss"></style>



// WEBPACK FOOTER //
// ge-cta-arrow.vue?acb2dd26